import styled from "styled-components";

export const BackStyled = styled.div`
  .back_btn {
    width: 42px;
    height: 42px;
    background-color: #f5f5f5;
    border-radius: 8px;
    .icon {
      color: #EB5B00;
      font-size: 28px;
    }
  }
`;
